import ActivitiesDashboard from "pages/property/overview/activities";
import Complaint from "pages/property/overview/complaint";
import Facility from "pages/property/overview/facility";
import HomeCare from "pages/property/overview/home-care";
import Juristic from "pages/property/overview/juristic";
import NewsAndAnnouncement from "pages/property/overview/news-and-announcement";
import Parcel from "pages/property/overview/parcel";
import Resident from "pages/property/overview/residents";
import SaleAndRent from "pages/property/overview/sale-and-rent";
import Survey from "pages/property/overview/survey";
import Vehicle from "pages/property/overview/vehicle";
import Voting from "pages/property/overview/voting";
import WorkPlan from "pages/property/overview/work-plan";
import WorkSpaceDashboard from "pages/property/overview/work-space";

export const CODE_MENU = [
  "2100",
  "2300",
  "2400",
  "2500",
  "0600",
  "2700",
  "2900",
  "4100",
  "5000",
  "2800",
  "3100",
  "3300",
  "3600",
  "3900",
];

export const DATA_PAGE_OVERVIEW_PROPERTY: { [T: string]: JSX.Element } = {
  "5000": <WorkPlan />,
  "4100": <Survey />,
  "2100": <NewsAndAnnouncement />,
  "2300": <HomeCare />,
  "2400": <Parcel />,
  "2900": <Complaint />,
  "2500": <Facility />,
  "2700": <Resident />,
  "0600": <Juristic />,
  "2800": <Vehicle />,
  "3100": <SaleAndRent />,
  "3300": <Voting />,
  "3600": <WorkSpaceDashboard />,
  "3900": <ActivitiesDashboard />,
};
